export default __webpack_public_path__ + "static/media/Hong Lien.db0189f4.png";